import type { ApiRoute, NoBody, NoPathParams } from "../../../api"
import type { StandardEquipmentView } from "./StandardEquipmentView"

export interface GetStandardEquipmentQueryParams {
	"inventory-id": string
}

export const getStandardEquipmentRoute: ApiRoute<
	NoPathParams,
	GetStandardEquipmentQueryParams,
	NoBody,
	StandardEquipmentView
> = {
	buildUrl: () => "/standard-equipment",
	method: "get",
	path: "/standard-equipment",
}
